import { createApi } from '@redux/createApi';
import { createSlice } from '@reduxjs/toolkit';
import { serialize } from '../../../shared/lib/serialize';
import { format } from '../../../shared/lib/format';

const tags = {
  getAdminLogs: 'getAdminLogs',
  getEndpoints: 'getEndpoints',
};

export const adminLogsApi = createApi({
  reducerPath: 'adminLogsApi',
  tagTypes: [tags.getAdminLogs, tags.getEndpoints],
  endpoints: (builder) => ({
    getAdminLogs: builder.query({
      query: (queryParams) => {
        const [limit, start, end, cursor] = queryParams;

        let params = {
          page_size: limit,
        };

        if (cursor) {
          params = {
            ...params,
            cursor: cursor,
          };
        }

        if (start) {
          params = {
            ...params,
            start: `${start.getDate()}/${format.addZeroBefore(start.getMonth() + 1)}/${start.getFullYear()}`,
          };
        }

        if (end) {
          params = {
            ...params,
            end: `${end.getDate()}/${format.addZeroBefore(end.getMonth() + 1)}/${end.getFullYear()}`,
          };
        }

        const queryString = serialize(params);
        return { url: `/user-history/history/v2?${queryString}`, method: 'GET' };
      },
      providesTags: [tags.getAdminLogs],
    }),

    getEndpoints: builder.query({
      query: () => ({
        url: '/user-history/endpoint/list',
      }),
      providesTags: [tags.getEndpoints],
    }),

    setEndpoints: builder.mutation({
      query: (endpoints) => ({
        url: '/user-history/set-endpoints',
        method: 'POST',
        body: endpoints,
      }),
      invalidatesTags: [tags.getEndpoints],
    }),
  }),
});

export const {
  useGetAdminLogsQuery,
  useGetEndpointsQuery,
  useSetEndpointsMutation,
} = adminLogsApi;

// Slice for managing filters and pagination parameters
const initialState = {
  limit: 100,
  start: (() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  })(),
  end: new Date(),
  cursor: null,
  cursorStack: [],
};

export const adminLogsParamsSlice = createSlice({
  name: 'adminLogsParams',
  initialState,
  reducers: {
    setParams: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetParams: () => initialState,
  },
});

export const { setParams, resetParams } = adminLogsParamsSlice.actions;
export const adminLogsParamsReducer = adminLogsParamsSlice.reducer;
export const adminLogsParamsSelector = (state) => state.adminLogsParams; 